import React from "react";
import StyleQuestion from "../../components/StyleQuestion";

const StyleQuestionContainer = ({
  setshowStyleEdit,
  stateObject,
  setstateObject,
  hideAnswerStyle,
}) => {
  return (
    <StyleQuestion
      setshowStyleEdit={setshowStyleEdit}
      stateObject={stateObject}
      setstateObject={setstateObject}
      hideAnswerStyle={hideAnswerStyle}
    ></StyleQuestion>
  );
};

export default StyleQuestionContainer;
